var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.617 16.426a1.5 1.5 0 102.77 1.148 1.5 1.5 0 00-2.77-1.148zM10.709 7.431a1.36 1.36 0 00-.06.562l.526 5.26a.828.828 0 001.65 0l.525-5.26a1.356 1.356 0 00-2.36-1.05 1.358 1.358 0 00-.281.488z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.852.726c.258.15.473.365.621.623l10.284 17.5c.687 1.166-.137 2.651-1.47 2.651H1.717c-1.333 0-2.155-1.483-1.47-2.65l10.286-17.5a1.695 1.695 0 012.32-.624zM11.826 2.11a.22.22 0 01.081-.086.195.195 0 01.096-.024c.034 0 .067.008.096.024.034.02.062.05.081.086l10.284 17.5a.264.264 0 01.005.275.244.244 0 01-.083.09.18.18 0 01-.099.025H1.717a.167.167 0 01-.098-.025.23.23 0 01-.081-.09.264.264 0 01.003-.275l10.285-17.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "e99f66dcbe1ec1fda8b2515f7281abf6.svg";
export { MemoForwardRef as ReactComponent };